import { connect } from 'react-redux';
import { getMetaData } from 'Seo/selectors';
import MetaDataContainer from './meta_data_container';

export default connect(getMetaData)(MetaDataContainer);
